import { render } from "./UserInfoComponent.vue?vue&type=template&id=a4a07248&scoped=true&ts=true"
import script from "./UserInfoComponent.vue?vue&type=script&lang=ts"
export * from "./UserInfoComponent.vue?vue&type=script&lang=ts"

import "./UserInfoComponent.vue?vue&type=style&index=0&id=a4a07248&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4a07248"]])

export default __exports__